import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as esgApi from '../../lib/api/esg';

const [LIST_ESG_FILES, LIST_ESG_FILES_SUCCESS, LIST_ESG_FILES_FAILURE] =
  createRequestActionTypes('esg/LIST_ESG_FILES');

export const listEsgFiles = createAction(
  LIST_ESG_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);

const listEsgFilesSaga = createRequestSaga(
  LIST_ESG_FILES,
  esgApi.getEsgFiles,
);

const UNLOAD_ESG_FILES = 'esg/UNLOAD_ESG_FILES';
export const unloadEsgFiles = createAction(UNLOAD_ESG_FILES);

export function* esgFilesSaga() {
  yield takeLatest(LIST_ESG_FILES, listEsgFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const esgFiles = handleActions(
  {
    [LIST_ESG_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUuid: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1,
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
      })),
      error: null,
    }),
    [LIST_ESG_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_ESG_FILES]: () => initialState,
  },
  initialState,
);

export default esgFiles;
